import _ from "lodash";

export const getPanelScrollHeight = () => {
  // size needs to be small enough so that window does not scroll when panels open
  const height = window.innerHeight * 0.75 - 100;

  return `${_.clamp(Math.round(height), 200, 340)}px`;
};
